import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function ServicesIndex() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(r => setServices(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="services-index">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Division Directory</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">
        Ten removal divisions.
      </h1>
      <p className="text-gray-700 mt-4 max-w-2xl">Every category of removal we operate, across 30,000+ cities in the USA and Canada.</p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-300 border border-gray-300">
        {services.map((s, i) => (
          <Link key={s.slug} to={`/service/${s.slug}`} className="bento-card p-8" data-testid={`service-row-${s.slug}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="mono text-[10px] tracking-[0.22em] uppercase text-gray-500">// {String(i+1).padStart(2, "0")} · {s.category}</div>
                <h3 className="display-black text-2xl lg:text-3xl uppercase text-[#064E3B] mt-2">{s.name}</h3>
                <div className="mono text-[12px] text-[#D97706] mt-2 uppercase tracking-wider">{s.tagline}</div>
                <p className="text-sm text-gray-700 mt-4 max-w-xl">{s.summary}</p>
              </div>
              <ArrowRight className="w-6 h-6 text-[#064E3B] shrink-0 mt-2" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
